const common = {
  SS_KEY_FILTERS: 'user filters',
  SS_KEY_FAVORITES: 'favorites-page',
  LS_KEY_FAVORITES: 'favorites',
  LS_KEY_QUOTE: 'quote',
  BASE_QUOTE: {
    author: 'Tom Brady',
    quote:
      "A lot of times I find that people who are blessed with the most talent don't ever develop that attitude, and the ones who aren't blessed in that way are the most competitive and have the biggest heart.",
  },
  ERROR_MESSAGE: 'Something goes wrong!',
};

export { common };
